<div class="ap-animation-container" #container [ngStyle]="{ height: height(), width: width() }"></div>
